import React from 'react';
import styled from 'styled-components/macro';
import { StyledIcon } from '../../ui/StyledIcon';
import { faCloudDownload } from '@fortawesome/pro-light-svg-icons';
import { CurrencySymbols } from 'src/shared/constants/currency';

export type PurchaseOption = {
  currency: string;
  id: string;
  price: number;
  quality: string;
  size: string;
  title: string;
};

type Props = {
  purchaseOptions: Array<PurchaseOption>;
  onClick: (purchaseOption: PurchaseOption) => void;
};

export const PurchaseDownloadDropdownMenu = (props: Props) => {
  const { purchaseOptions, onClick } = props;

  return (
    <PurchaseMenuWrapper>
      {purchaseOptions.map((purchaseOption) => {
        const { currency, id, price, title } = purchaseOption;
        return (
          <Row key={id} onClick={() => onClick(purchaseOption)}>
            <div className="row-items">
              <StyledIcon $spaceRight icon={faCloudDownload} />
              Download
            </div>
            <div className="row-items middle-item">{title}</div>
            <div className={`row-items last-item ${title.split(' ').reverse().join('-').toLowerCase()}`}>
              <span>
                {currency}
                {currency === CurrencySymbols.JPY ? price : price.toFixed(2)}
              </span>
              <BuyTag>BUY</BuyTag>
            </div>
          </Row>
        );
      })}
      <Footer>100% DRM Free Digital Download and Instant Online Streaming</Footer>
      <div className="footer-section">
        <span className="footer"></span>
      </div>
    </PurchaseMenuWrapper>
  );
};

const PurchaseMenuWrapper = styled.div`
  & .row-items {
    font-size: 0.9rem;
    display: flex;
    width: inherit;
    flex: 1;
    align-items: center;

    @media (max-width: 442px) {
      padding-left: 0;
    }

    i {
      color: #000;
    }
  }

  & .middle-item {
    justify-content: left;
    padding-left: 36px;
    white-space: nowrap;
    min-width: 110px;
  }

  & .last-item {
    flex-grow: 2;
    justify-content: flex-end;
    padding-left: 16px;
  }
`;

const Row = styled.div`
  color: #000;
  cursor: pointer;
  display: flex;
  margin-bottom: 12px;
  padding: 6px 16px;
  text-decoration: none;
  width: 100%;

  :hover {
    background: #d7d7d7;
  }
`;

const BuyTag = styled.div`
  font-weight: 100;
  font-size: 0.7rem;
  border-radius: 1px;
  background: #777;
  color: #fff;
  margin-left: 1em;
  padding: 0.25em 0.5em;

  ${Row}:hover & {
    background: #40a03e;
  }
`;

const Footer = styled.div`
  color: #000;
  font-size: 0.65rem;
  margin: 9px auto;
  text-align: center;
`;
